import { useViewer } from "@/authentication/ViewerProvider"
import { Button } from "@/components/ui/button"
import { H1 } from "@/components/ui/headings"
import Panel from "@/components/ui/panel"
import { cn } from "@/lib/utils"
import Pencil from "@/novus/assets/images/pencil.svg"
import { Avatar } from "@/novus/components/avatar"
import { useCurrentOrganization } from "@/novus/hooks/useCurrentOrganization"
import { editProfilePath } from "@/novus/novus-paths"
import { userName } from "@/util/users"
import pluralize from "pluralize"
import React from "react"
import { Link } from "react-router-dom"

const ContentSquare = ({ title, count }: { title: string; count: number }) => {
  return (
    <div
      className={cn(
        "flex flex-col flex-1 items-center px-6 pt-3.5 pb-5",
        "md:px-12",
      )}
    >
      <div className="text-base">{count}</div>
      <div className="text-xs text-textPrimary text-center">{title}</div>
    </div>
  )
}

const MemberProfilePanel = ({
  fiveTwoNineAccountsCount,
  deductionsCount,
}: {
  fiveTwoNineAccountsCount: number
  deductionsCount: number
}) => {
  const { viewer } = useViewer()
  const { organization } = useCurrentOrganization()

  return (
    <div>
      <H1>Member Profile</H1>
      <Panel>
        <div className="absolute right-7 top-7">
          <Button asChild={true} size="sm" variant="outline">
            <Link to={editProfilePath.pattern}>
              <div className="flex flex-row gap-2">
                <img
                  src={Pencil}
                  alt="Edit"
                  className=""
                  height={10}
                  width={10}
                />
                Edit
              </div>
            </Link>
          </Button>
        </div>
        <div className="flex flex-col items-center gap-7">
          <Avatar viewer={viewer} size="lg" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-2xl">{userName(viewer)}</div>
            <div className="flex text-neutral-400 text-sm">
              <div>{viewer.email}</div>
              {!!organization && (
                <>
                  <div className="mx-2">|</div>
                  <div>{organization.name}</div>
                </>
              )}
            </div>
          </div>
          <div className="rounded-md shadow-custom-md flex-1 divide-x border border-1 border-neutral-200 flex max-w-[335px]">
            <ContentSquare
              count={fiveTwoNineAccountsCount}
              title={pluralize("Beneficiary", fiveTwoNineAccountsCount)}
            />
            <ContentSquare
              count={deductionsCount}
              title={pluralize("Deduction", deductionsCount)}
            />
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default MemberProfilePanel
